export default __webpack_public_path__ + "static/media/7.0ef9e015.svg";